import dayjs from 'dayjs';
import { DateTimeLlFormat } from '../../constants/data';

const ChartSoilTooltip = ({ active, payload, label, selectedDeep, units }) => {
  if (active && payload && payload.length) {
    const payloadData = payload[0].payload;
    const list = [];
    selectedDeep.map((el) => {
      let currentValue;
      switch (el.value) {
        case '10':
          currentValue = payloadData.value10;
          break;
        case '20':
          currentValue = payloadData.value20;
          break;
        case '30':
          currentValue = payloadData.value30;
          break;
        case '40':
          currentValue = payloadData.value40;
          break;
        case '50':
          currentValue = payloadData.value50;
          break;
        case '60':
          currentValue = payloadData.value60;
          break;
        case '70':
          currentValue = payloadData.value70;
          break;
        case '80':
          currentValue = payloadData.value80;
          break;
        default:
          currentValue = payloadData.value90;
      }
      list.push({
        value: currentValue,
        label: `${el.value} cm`,
        color: el.color,
      });
    });

    return (
      <div className={`chart-tooltip`}>
        <div className="chart-tooltip__header">{dayjs(label).format(DateTimeLlFormat)}</div>
        {list &&
          list.length > 0 &&
          list.map((item, index) => (
            <div key={'tooltip' + index} className="chart-tooltip__item">
              <div className="chart-tooltip__title" style={{ color: item.color }}>
                <span>{item.label}</span>
              </div>
              <div className="chart-tooltip__value">
                <span>{`${item.value}${units}`}</span>
              </div>
            </div>
          ))}
      </div>
    );
  }

  return null;
};

export default ChartSoilTooltip;